export const ProjectTooltip = () => (
    <>
        <p>
            Help us get a better sense of what you&apos;re working on & where the work will live. Select any that might
            apply.
        </p>
        <a
            className="text-giphyWhite underline"
            target="_blank"
            rel="noreferrer"
            href="https://support.giphy.com/hc/en-us/articles/360022661172-Hire-A-GIF-Artist-"
        >
            Learn More about GIF Commissions
        </a>
    </>
)
export const BudgetTooltip = () => (
    <>
        <p>Rates tend to vary! Consider the scope of work and a fair day rate to help calculate this.</p>
        <a
            target="_blank"
            rel="noreferrer"
            href="https://support.giphy.com/hc/en-us/articles/360022661172-Hire-A-GIF-Artist-"
        >
            Learn More about GIF Commissions
        </a>
    </>
)

export const Success = () => {
    return <div className="grid flex-1 place-items-center text-3xl font-bold">Inquiry Sent</div>
}
